import { render, staticRenderFns } from "./ResultsDisplayer.vue?vue&type=template&id=91a6cf1e&"
import script from "./ResultsDisplayer.vue?vue&type=script&lang=js&"
export * from "./ResultsDisplayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports